import Welcome from '../../components/Welcome/Welcome';
import DocumentTitle from '../../components/Title/Title';

const WelcomePage = () => {
  return (
    <>
      <DocumentTitle>Welcome Page</DocumentTitle>
      <Welcome />
    </>
  );
};

export default WelcomePage;
